//@flow
// Make polyglot available on window for our older, browser JS

import t, { tList } from 'shared/utils/translation';

window.Greenhouse.Translation = window.Greenhouse.Translation || {};
window.Greenhouse.Translation.t = t;
window.Greenhouse.Translation.tList = tList;
